export const PROJECT_CATEGORIES = ["React", "Django", "NodeJS", "Unity", "Mobile"];
